<router-outlet></router-outlet>

<ng-container *ngIf="loaderService.loaderSub | async as loader">
  <app-loader [message]="loader.message" *ngIf="loader.show"></app-loader>
</ng-container>

<p-toast [baseZIndex]="1000005"></p-toast>
